import { useCreateQueryKeys as e } from "@maat/store-hooks";
//#region src/experiences/useExperienceQueryKeys.ts
var t = e("experiences", {
	list: (e) => e ? ["list", e] : ["list"],
	detail: (e) => ["detail", e]
});
//#endregion
export { t as experienceQueryKeys };
